import script from "./pdfViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./pdfViewer.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__